<template>
  <v-app class="bgImage">
    <m-errorbox ref="errorBox"></m-errorbox>
    <navbar>
        <v-toolbar-title
            class="text-uppercase secondary--text text--darken-3"
        >
            <span class="font-weight-light">Device </span>
            <span class="font-weight-medium">Status</span>
        </v-toolbar-title>
        <v-spacer></v-spacer>
    </navbar>
    <v-content class="secondary--text text--darken-2">
      <v-container fluid>
        <v-row>
            <v-col lg="2" md="3" sm="4">
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>
                                Parameter
                            </th>
                            <th>
                                Value
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(statItem, statIndex) in deviceStatus" :key="statItem[0]">
                            <td class="font-weight-bold text-right">
                                {{statItem[0]}}:
                            </td>
                            <td class="text-right">
                                {{statItem[1]}} {{calRecords[statIndex] && calRecords[statIndex].units}}
                            </td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import usbRequest from '../mixins/usb-request';



export default {
    mixins:[usbRequest],
  data() {
    return {
      deviceStatus:[],
      calRecords:{},
      calReadings:[],
      //calMode:false,
      calMode:true,
      factoryMode:false,
    };
  },
  async mounted(){
    //this.usbRequest('device', this.$route.params.id).then(r=>console.log(r));
    this.getCalRecords();
    this.pollUsbDevice();

  },
  methods:{
    showError(message){
        this.$refs.errorBox.showError(message);
    },
    async pollUsbDevice(){
        this.deviceStatus = await this.usbGetStatus();
        // only re-run the polling loop whilst we are on this route.
        if (this.$router.currentRoute.name == "usbdevicestatus"){
            setTimeout(this.pollUsbDevice, 500);
        }
    },
    async getCalRecords(){
        this.calRecords = await this.usbGetCalRecords();
    },
  }
};
</script>
